import { MODEL_TARGET_PATH_SEPARATOR } from '../sidebar.constant';

export class MenuSettings {
    constructor(public targetPathSeparator = MODEL_TARGET_PATH_SEPARATOR) {
    }
}
